export default __webpack_public_path__ + "static/nourishingHope202506-cd49e5048c5d42d256f8db878873c9f9.jpg";